import { render, staticRenderFns } from "./PageResetPassword.vue?vue&type=template&id=edd0f856&"
import script from "./PageResetPassword.vue?vue&type=script&lang=js&"
export * from "./PageResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports